import styled from 'styled-components'
const Wrapper = styled.div`
.resource-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    cursor : pointer;
}

    .resource-container span{
    color: #1D1D1D;

    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

   
    .card{
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    }
.cus-date {
display :block;
  flex: 1;
  width: 100% !important;
}
.react-datepicker-wrapper{
display :block;

}
.input-group {
    position: relative;
    display: flex
;
    flex-wrap: inherit;
    align-items: stretch;
    width: 100%;
}
.react-datepicker-wrapper{
    width: -webkit-fill-available;
}





.dropzone {
  border: 1px dashed #aaa;
  padding: 4rem;
  border-radius: 8px;
  text-align: center;
  color: #666;
  cursor: pointer;
  transition: border 0.2s ease;
  background-color: #f9f9f9;
}

.dropzone.active {
  border-color: #007bff;
  background-color: #eef6ff;
}

.error-msg {
  color: red;
  font-size: 0.875rem;
}

.btn-grey {
    border-radius: 12px;
    background: #B4B3B4;
    height: 50px;
    padding: 10px 24px;
    justify-content: center;
    gap: 8px;
    align-self: stretch;
    color: white;
    display: flex;
    width: -webkit-fill-available;
    align-items: center;
    font-size: 1.2rem;
}

.btn-blue {
    border-radius: 12px;
    background: #0B3C5D;
    height: 50px;
    padding: 10px 24px;
    justify-content: center;
    gap: 8px;
    align-self: stretch;
    color: white;
    display: flex;
    width: -webkit-fill-available;
    align-items: center;
    font-size: 1.2rem;
}

.btn-upload{
    border-radius: 12px;
    background: #bc671b;
    height: 50px;
    padding: 10px 24px;
    justify-content: center;
    gap: 8px;
    align-self: stretch;
    color: white;
    display: flex;
    width: -webkit-fill-available;
    align-items: center;
    font-size: 1.2rem;
}
}
.btn-blue-small {
  border-radius: 12px;
  background: #0B3C5D;
  height: 40px;
  padding: 10px 24px;
  justify-content: center;
  gap: 8px;
  align-self: stretch;
  color: white;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.2s ease;
}

.btn-blue-small:hover {
  background: #0a2f47; /* darker shade for hover */
  transform: translateY(-1px); /* subtle lift effect */
  color:#fff;
}


.preview-area {
     border: 2px dashed #ccc;
    padding: 1rem;
    background: #f9f9f9;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
}


@media (max-width: 768px) {
    .dropzone {
         padding: 0rem !important;
    }
    .btn-grey , .btn-blue{
          padding: 0px 2px !important;   
    }
          .btn-conainer {
    display: flex;
    flex-direction : column;
    gap: 0rem !important;
}
}

video {
    height: 24rem;
    width: 100%;
}

@media (max-width: 768px) {
    video {
        height: auto;
    }
        .card-body {
    padding: 10px 10px !important;
}

}

audio {
        width: -webkit-fill-available;
    }

    .btn-conainer{
        display: flex;
        gap: 1rem;
    }


    .dropdown-submenu {
  position: relative;
}
.dropdown-submenu > .dropdown-menu {
  top: 0;
  left: 100%;
  margin-left: 0.1rem;
  display: none;
}
.dropdown-submenu:hover > .dropdown-menu {
  display: block;
}


.attendees-header-modal{
    display: flex;
    justify-content: space-between;
    margin: 1rem;
}

.gender-Cast-wise-box{
  display: flex;
  padding: 1.25rem;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  align-self: stretch;
  border-radius: 0.625rem;
  border: 1px dashed #919191;
  background: #F4F8FC;
}
.gender-Cast-wise-box p {
    color: #696769;
    text-align: center;
    font-size: 1rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}


.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4); /* dark overlay */
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px); /* Safari */
  z-index: 1040; /* lower than modal */
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.backdrop.show {
  opacity: 1;
}

.modal.fade {
  opacity: 0;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  transform: scale(0.95);
}

.modal.fade.show {
  opacity: 1;
  transform: scale(1);
  z-index: 1050; /* higher than backdrop */
}

.attendees-summary-box{
border-radius: 0.625rem;
border: 1px dashed #999999;

}

.gender-data-p p{
  margin-bottom : 3px
}

.cast-data-p p{
  margin-bottom : 3px
}

.cast-data-p {
  display: grid;
    grid-template-columns: 1fr 1fr;
}
}

 `
export default Wrapper